import React from "react";
import EasasGlobalAlerts from "./EasasGlobalAlerts";
import EasasGlobalChartDialog from "./EasasGlobalChartDialog";
import EasasGlobalConfirmDialog from "./EasasGlobalConfirmDialog"

export default function EasasGlobalFragment() {
    return <>
        <EasasGlobalAlerts/>
        <EasasGlobalChartDialog/>
        <EasasGlobalConfirmDialog/>
    </>
}